import { POST } from "../APiHelper/API"


export const addConversationMessage = (conversation_id, message, onSuccess, onError) => {
    const data = {
        conversation_id: conversation_id,
        message: message
    }
    POST("/api/v1/conversations/add_message", data, onSuccess, onError)
}